<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1300px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-account-plus
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Participants"
      text="Participant List"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-card class="pa-4 elevation-5">
                <v-text-field
                  v-model="searchInput"
                  placeholder="Filter employee by name"
                  append-icon="search"
                  label="Search Employee"
                  hide-no-data
                  hide-selected
                />

                <v-autocomplete
                  v-model="position"
                  :items="positions"
                  item-text="name"
                  item-value="id"
                  label="Position"
                  placeholder="Position Filter"
                  clearable
                  hide-selected
                  multiple
                  chips
                  deletable-chips
                  @change="search"
                />

                <v-autocomplete
                  v-model="branch"
                  :items="branches"              
                  label="Branch"
                  placeholder="Branch Filter"
                  item-text="branch_name"
                  item-value="branch_uid"              
                  clearable
                  hide-selected
                  multiple
                  chips
                  deletable-chips
                  @change="search"
                />

                <v-data-table
                  v-model="selectedParticipants"
                  dense
                  :loading="participantListLoading"
                  :headers="participantListHeaders"
                  :items="searchedParticipants"
                  hide-default-footer
                  fixed-header
                  disable-pagination
                  item-key="person.name"
                  show-select
                  class="elevation-1 mb-3 table"
                  height="253px"
                  hide-selected
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                      color="white"
                    >
                      <v-toolbar-title>Add Participants To:</v-toolbar-title>
                    </v-toolbar>
                  </template>
                </v-data-table>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    v-if="$hasPermissionTo(['update training participants'])"
                    :loading="addParticipantProgressing"
                    color="success"          
                    @click="submitForm"
                  >
                    Add to training
                    <v-icon
                      right
                      dark
                    >
                      mdi-arrow-right-bold-circle-outline
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-col cols="6">
              <v-card class="pa-4 elevation-5">
                <v-text-field
                  v-model="searchTrainingParticipantInput"
                  placeholder="Filter employee by name"
                  append-icon="search"
                  label="Search Employee"
                  hide-no-data
                  hide-selected
                />
                <v-data-table
                  v-model="selectedTrainingParticipants"
                  dense
                  :loading="participantTableLoading"
                  :headers="trainingParticipanHeaders"
                  :items="filteredTrainingParticipants"
                  hide-default-footer
                  fixed-header
                  disable-pagination
                  item-key="employee.person.name"
                  item-value="employee_uid"
                  show-select
                  class="elevation-1 mb-3 table"
                  height="394px"
                >
                  <template v-slot:item.is_present="{ item }">
                    <v-icon 
                      v-if="item.is_present === 1" 
                      color="success"
                    >
                      mdi-check
                    </v-icon>
                  </template>

                  <template v-slot:top>
                    <v-toolbar
                      flat
                      color="white"
                    >
                      <v-toolbar-title>Participant List:</v-toolbar-title>
                    </v-toolbar>
                  </template>
                </v-data-table>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    v-if="$hasPermissionTo(['delete training participants']) && hideRemoveBtn"
                    :loading="removeParticipantLoading"
                    color="error"
                    @click="removeParticipant"
                  >
                    Remove Participant 
                    <v-icon
                      right
                      dark
                    >
                      mdi-arrow-left-bold-circle-outline
                    </v-icon>
                  </v-btn>

                  <v-btn
                    v-if="$hasPermissionTo(['update training attendance']) && hideAttendanceBtn"
                    :loading="unmarkLoading"
                    color="error"
                    @click="revertAttendance"
                  >
                    Unmark Attendance 
                    <v-icon
                      right
                      dark
                    >
                      mdi-clipboard-text
                    </v-icon>
                  </v-btn>

                  <v-btn
                    v-if="$hasPermissionTo(['update training attendance']) && hideAttendanceBtn"
                    :loading="markLoading"
                    color="success"          
                    @click="submitAttendanceForm"
                  >
                    Mark Attendance
                    <v-icon
                      right
                      dark
                    >
                      mdi-clipboard-text
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="closeDialog"
        >
          Close
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      session: {
        type: Object,
        default: null,
      },
    },
 
    data () {
      return {
        participantListLoading: false,
        addParticipantProgressing: false,
        unmarkLoading: false,
        markLoading: false,
        removeParticipantLoading: false,
        dialog: null,
        hideAttendanceBtn: false,
        hideRemoveBtn: true,
        participantListHeaders: [
          { text: 'Name', value: 'person.name', sortable: false },
        ],
        searchInput: '',
        trainingParticipants: [],
        trainingParticipanHeaders: [
          { text: 'Name', value: 'employee.person.name' },
          { text: 'Attendance', value: 'is_present', align: 'center' },
        ],
        selectedTrainingParticipants: [],
        searchTrainingParticipantInput: '',
        participantTableLoading: true,
        position: [],
        branch: [],
        positions: [],
        branches: [],
        searchedParticipants: [],
        selectedParticipants: [],
        selectedParticipantIds: [],
      }
    },

    computed: {
      filteredTrainingParticipants () {
        let _this = this
        _this.searchTrainingParticipantInput = _this.searchTrainingParticipantInput.trim()

        let primaryFilterEmployees = this.trainingParticipants.filter(function (employee) {
          return ((employee.employee.person || {}).name || '').toLowerCase().indexOf(_this.searchTrainingParticipantInput.toLowerCase()) !== -1 
        })

        return primaryFilterEmployees
      },
    },

    watch: {
      dialog: function (value) {
        if (!value) return
        this.loadData()
        this.trainingSessionStartedChecking(this.session)
      },
      searchInput: function (value) {
        this.search()
      },
    },
    methods: {
      search: _.debounce(function () {
        this.participantListLoading = true

        this.$api.trainingParticipants().search(this.prepareSearchFormData())
          .then(res => {
            if (this.branch.length > 0 || this.position.length > 0 || this.searchInput) {
              if (this.selectedParticipantIds.length > 0) {
                this.searchedParticipants = res.data.filter(item => {
                  if (!this.selectedParticipantIds.includes(item.employee_uid)) {
                    return true
                  }
                }).sort((a, b) => (a.person.name > b.person.name) ? 1 : -1)
              } else {
                this.searchedParticipants = res.data.sort((a, b) => (a.person.name > b.person.name) ? 1 : -1)
              }
            } else {
              this.searchedParticipants = []
            }
          }).catch(() => {})
          .then(res => {
            this.participantListLoading = false
          })
      }, 1000),

      trainingSessionStartedChecking (session) {
        let today = new Date()
        let date = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2)
        let time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()

        if ((date > session.date) && (time > session.time)) {
          this.hideAttendanceBtn = true
          this.hideRemoveBtn = false
        } 
      },

      revertAttendance () {
        this.$validator.validateAll().then(result => {
          if (!result) return

          this.unmarkLoading = true

          this.$api.trainingParticipants().revertAttendance(this.session.id, this.prepareAttendanceFormData())
            .then(res => {
              if (res.status === 200) {
                this.selectedTrainingParticipants = []
                this.loadTrainingParticipants()
                this.$snack({ message: 'Participants Attendance updated Succesfully' })
              }
            })
            .catch(error => {
              if (error.response.status === 400) {
                this.$snack({ 
                  color: 'error',
                  message: error.response.data.status, 
                })
              }
            })
            .then(() => {
              this.unmarkLoading = false
            })
        })
      },

      loadData () {
        Promise.all([
          this.$api.trainingParticipants().list(this.session.id),
          this.$api.positions().list(),
          this.$api.branches().list(),
        ])
          .then(([participants, positions, branches]) => {
            this.trainingParticipants = _.orderBy(participants.data, ['is_present', 'employee.person.name'], ['desc', 'asc'])
            this.selectedParticipantIds = []
            participants.data.map(item => {
              this.selectedParticipantIds.push(item.employee_uid)
            })
            this.positions = positions.data
            this.branches = branches.data
            this.participantTableLoading = false
          })
      },
         
      prepareAttendanceFormData () {
        let selectedTrainingParticipantIds = []
        this.selectedTrainingParticipants.map(item => {
          selectedTrainingParticipantIds.push(item.employee_uid)
        })

        return selectedTrainingParticipantIds
      },

      submitAttendanceForm () {
        this.$validator.validateAll().then(result => {
          if (!result) return

          this.markLoading = true

          this.$api.trainingParticipants().attendance(this.session.id, this.prepareAttendanceFormData())
            .then(res => {
              if (res.status === 200) {
                this.selectedTrainingParticipants = []
                this.loadTrainingParticipants()
                this.$snack({ message: 'Participants Attendance updated Succesfully' })
              }
            })
            .catch(error => {
              if (error.response.status === 400) {
                this.$snack({ 
                  color: 'error',
                  message: error.response.data.status, 
                })
              }
            })
            .then(() => {
              this.markLoading = false
            })
        })
      },

      loadTrainingParticipants () {
        this.participantTableLoading = true

        this.$api.trainingParticipants().list(this.session.id)
          .then((res) => {
            this.trainingParticipants = _.orderBy(res.data, ['is_present', 'employee.person.name'], ['desc', 'asc'])

            this.selectedParticipantIds = []
            res.data.map(item => {
              this.selectedParticipantIds.push(item.employee_uid)
            })
            this.participantTableLoading = false
          })
      },

      submitForm () {
        this.$validator.validateAll().then(result => {
          if (!result) return

          this.addParticipantProgressing = true

          this.$api.trainingParticipants().update(this.session.id, this.prepareFormData())
            .then(res => {
              if (res.status === 200) {
                this.selectedParticipants = []
                this.loadTrainingParticipants()
                this.search()
                this.$snack({ message: 'Participants added Succesfully' })
              }
            })
            .catch(() => {})
            .then(() => {
              this.addParticipantProgressing = false
            })
        })
      },

      prepareFormData () {
        let selectedParticipantIds = []
        this.selectedParticipants.map(item => {
          selectedParticipantIds.push(item.employee_uid)
        })
        return selectedParticipantIds
      },

      removeParticipant () {
        this.$validator.validateAll().then(result => {
          if (!result) return
          this.removeParticipantLoading = true
          this.$api.trainingParticipants().delete(this.session.id, this.prepareAttendanceFormData())
            .then(res => {
              if (res.status === 200) {
                this.selectedTrainingParticipants = []
                this.loadTrainingParticipants()
                this.search()
                this.$snack({ message: 'Participants removed Succesfully' })
              }
            })
            .catch(error => {
              if (error.response.status === 400) {
                this.$snack({ 
                  color: 'error',
                  message: error.response.data.status, 
                })
              }
            })
            .then(() => {
              this.removeParticipantLoading = false
            })
        })
      },

      closeDialog () {
        this.dialog = false
        this.$emit('updated')
      },

      prepareSearchFormData () {
        return {
          searchInput: this.searchInput,
          position: this.position,
          branch: this.branch,
        }
      },
    },
  }
</script>

<style>
.table tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}

::-webkit-scrollbar {
  width: 3px !important; 
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background:  #555; 
}
</style>
